"use strict";
module.exports = {
  MODE_ENV: "production",
  BASE_API: "https://prod.serviceplus.mil.cn/api/web",
  IMAGE_API: "https://prod.serviceplus.mil.cn/api"
};
